const getParameterByName = (name: string, search?: string): string => {
  const params = new URLSearchParams(search || window.location.search)
  const result = params.get(name)
  return result ? decodeURIComponent(result) : result
}

export default getParameterByName
